import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { PayrollReports } from "./PayrollReports";
import { StatutoryReports } from "./StatutoryReports";

// Payroll > Reports is a sidebar flyout (see routes.js). Its URLs follow
// this folder's structure:
//   /admin/payroll/reports/payroll-reports   -> Reports/PayrollReports
//   /admin/payroll/reports/statutory-reports -> Reports/StatutoryReports
// One hidden route (/admin/payroll/reports) serves both, since routes are
// matched by prefix, and this component picks the screen from the path.
export const PAYROLL_REPORTS_BASE_PATH = "/admin/payroll/reports";
export const PAYROLL_REPORT_PATHS = {
  payroll: `${PAYROLL_REPORTS_BASE_PATH}/payroll-reports`,
  statutory: `${PAYROLL_REPORTS_BASE_PATH}/statutory-reports`,
};

export const PayrollReportsHub = () => {
  const { pathname } = useLocation();
  const path = pathname.replace(/\/+$/, "");

  if (path.startsWith(PAYROLL_REPORT_PATHS.statutory)) {
    return <StatutoryReports />;
  }
  if (path.startsWith(PAYROLL_REPORT_PATHS.payroll)) {
    return <PayrollReports />;
  }
  // Old /admin/payroll/reports links (and any unknown sub-path) land on
  // Payroll Reports under its new URL.
  return <Redirect to={PAYROLL_REPORT_PATHS.payroll} />;
};
